import React, { ReactNode } from "react";

import { OverlayTrigger, Popover } from "react-bootstrap";

export type LabelFormProps = {
  label?: string;
  labelInfos?: string | ReactNode;
  icon?: React.ComponentType<any> | React.ReactElement;
};

export const LabelForm = ({
  label,
  required,
  labelInfos,
  className,
  icon,
}: LabelFormProps & {
  required?: boolean;
  className?: string;
}) => {
  const overlayInfos = (
    <Popover>
      <Popover.Body className="d-flex gap-3">
        <i className="bi bi-info-circle-fill"></i>
        {labelInfos}
      </Popover.Body>
    </Popover>
  );

  const renderIcon = () => {
    if (!icon) return null;
    
    if (React.isValidElement(icon)) {
      return icon;
    }
    
    if (typeof icon === 'function') {
      const IconComponent = icon;
      return <IconComponent />;
    }
    
    return null;
  };

  return label ? (
    <label className={(className ? className : "") + "form-input_label mt-2 d-flex gap-2 align-items-center"}>
      {renderIcon()}
      {labelInfos ? (
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          overlay={overlayInfos}
        >
          <i className="bi bi-info-circle-fill"></i>
        </OverlayTrigger>
      ) : null}
      {label}
      {required ? (
        <span className="form-input_label-required">&nbsp;*</span>
      ) : null}
    </label>
  ) : null;
};
